import { Box } from '@mui/material'
import type { Theme } from '@mui/material/styles'
import { styled } from '@mui/material/styles'
import { DataGrid } from '@mui/x-data-grid'
import { red, shade } from '../../colors'

interface StyledTableWrapperProps {
  theme?: Theme
}

export const StyledTableWrapper = styled(Box)<StyledTableWrapperProps>(({ theme }) => ({
  backgroundColor: 'white',
  borderRadius: theme.spacing(3),
  border: `1px solid ${theme.palette.borderColor}`,
  boxShadow: ` 0px 1px 3px 0px ${shade[550]}`,
  overflow: 'hidden'
}))

interface StyledGridProps {
  theme?: Theme
  tableHeight?: string
  isRowClickable?: boolean
}
export const StyledDataGrid = styled(DataGrid)<StyledGridProps>(({ theme, tableHeight, isRowClickable }) => ({
  height: tableHeight,
  borderRadius: 0,
  columnGap: '100px',
  border: 'none',
  '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
    outline: 'none'
  },

  '& .MuiDataGrid-row:hover': {
    background: shade[750],
    cursor: isRowClickable ? 'pointer' : 'default'
  },

  '& .MuiDataGrid-columnHeader': {
    background: shade[750],
    fontSize: '12px',
    fontWeight: 500,
    height: '56px !important'

  },

  '& .MuiDataGrid-cell': {
    paddingLeft: theme.spacing(4),
    display: 'flex',
    alignItems: 'center'
  },

  '& .MuiDataGrid-scrollbar::-webkit-scrollbar': {
    height: theme.spacing(3),
    width: theme.spacing(0)
  },

  '& .MuiDataGrid-cell:focus': {
    outline: 0
  },

  '& .MuiDataGrid-footerContainer': {
    display: 'none'
  },

  '& .warning-highlight-cell': {
    backgroundColor: red[0],
    transition: 'background-color 300ms ease-in'
  }

}))

interface StyledTableHeaderProps {
  theme?: Theme
  isMobile: boolean
}

export const StyledTableHeader = styled(Box)<StyledTableHeaderProps>(({ theme, isMobile }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: isMobile ? 'column' : 'row',
  gap: isMobile ? theme.spacing(5) : theme.spacing(1),
  padding: `${theme.spacing(2)} ${theme.spacing(6)}`,
  borderBottom: `1px solid ${shade[650]}`
}))
